export default function (cli) {
  return {
    list () {
    },
    csvData (params, progressFn) {
      let items = []
      let request = (url, params) => {
        let tmp = cli.get(url)
        if (params) {
          tmp = tmp.query(params)
        }
        return tmp.then(res => {
          items = items.concat(res.body.results)
          if (res.body.next) {
            if (progressFn) {
              const cnt = res.body.count
              const tmp = res.body.next.match(/^.*\?.*offset=(\d+)/)
              const offset = tmp ? tmp[1] : 0
              progressFn(cnt, offset)
            }
            return request(res.body.next)
          } else {
            return items
          }
        })
      }
      return request(`${cli.apiEndpoint}csv-data/operation-histories/`, params)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/operation-histories.js